import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Stack, useTheme } from '@mui/material';
import axios from 'axios';
import { LoginButton } from '@telegram-auth/react';

import { loginSuccess } from '../../../redux/slices/auth';

const TelegramLogin = () => {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const handleTelegramAuth = async (user) => {
    try {
      setLoading(true);
      const response = await axios.post('ecommerce/auth/telegram/', user);
      loginSuccess(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Telegram Authentication failed:', error.response.data);
      setLoading(false);
    }
  };

  return (
    <Stack
      alignItems={'center'}
      justifyContent={'center'}
      sx={{
        width: '100%',
        background: '#54a9eb',
        padding: '5px',
        borderRadius: '100px',
        height: '48px',
        boxShadow: theme.customShadows.z8,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {loading && (
        <Stack
          alignItems={'center'}
          justifyContent={'center'}
          sx={{
            width: '100%',
            background: 'rgba(255,255,255,0.4)',
            position: 'absolute',
            height: '100%',
          }}
        >
          <CircularProgress
            size={28}
            sx={{
              zIndex: 100,
              color: '#fff',
            }}
          />
        </Stack>
      )}

      <LoginButton
        botUsername={'yiusvilla_bot'}
        onAuthCallback={handleTelegramAuth}
        buttonSize="large" // "large" | "medium" | "small"
        showAvatar // true | false
        lang="en"
      />
    </Stack>
  );
};

export default TelegramLogin;
